import { documentReady } from './utils';
import { 
  OverlayScrollbars 
} from 'overlayscrollbars';


const ScrollbarOverlay = {
    initialize: () => {
        documentReady(() => {                
            OverlayScrollbars(document.querySelector('.lgmp-terms__wrapper'), {});
            
            document.querySelectorAll('.comments-btn').forEach(x => {
                x.addEventListener('click', () => {
                    setTimeout(() => {
                        if(document.querySelector('.suggestions'))
                            OverlayScrollbars(document.querySelector('.suggestions'), {});
                    }, 500);
                });
            });
        });
    },

}

ScrollbarOverlay.initialize();

export default ScrollbarOverlay;
